/** This browser's own conveniences (a draft, a remembered view): localStorage can be missing,
 *  full or blocked (a private window), so every call may quietly do nothing. Never anything
 *  another device or person needs. */
export function readLocal(key: string): string | null {
  try {
    return window.localStorage.getItem(key);
  } catch {
    return null;
  }
}

export function writeLocal(key: string, value: string | null): void {
  try {
    if (value === null) window.localStorage.removeItem(key);
    else window.localStorage.setItem(key, value);
  } catch {
    // full or blocked: the convenience is simply off
  }
}

/** R9-A10: an unsent message, per conversation (and thread), in this browser only. */
const DRAFT = "vx.draft.";
const DRAFT_MAX = 20_000;

export function readDraft(key: string): string {
  return readLocal(DRAFT + key) ?? "";
}

export function writeDraft(key: string, text: string): void {
  writeLocal(DRAFT + key, text.trim() ? text.slice(0, DRAFT_MAX) : null);
}

/** A deleted chat leaves no draft behind (its own and its threads'). */
export function clearDraftsOf(conversationId: string): void {
  try {
    const store = window.localStorage;
    for (const key of Object.keys(store))
      if (key.startsWith(DRAFT) && key.includes(`:${conversationId}`)) store.removeItem(key);
  } catch {
    // blocked: nothing was kept either
  }
}

/** Signing out forgets every draft: the next person on this browser never sees them. */
export function clearDrafts(): void {
  try {
    const store = window.localStorage;
    for (const key of Object.keys(store)) if (key.startsWith(DRAFT)) store.removeItem(key);
  } catch {
    // blocked: nothing was kept either
  }
}
